import { useCallback, useState } from 'react';

import type { BannerAction } from '../promotionalBanners.type';
import { defaultBannerAction } from '../promotionalBanners.type';

export const useBannerAction = <T>() => {
    const [action, setAction] = useState<BannerAction<T>>(defaultBannerAction);

    const clearAction = useCallback(() => setAction(defaultBannerAction), []);

    const openCreateModal = useCallback(() => {
        setAction({ type: 'create', banner: null });
    }, []);

    const openEditModal = useCallback((banner: T) => {
        setAction({ type: 'edit', banner });
    }, []);

    const openViewModal = useCallback((banner: T) => {
        setAction({ type: 'view', banner });
    }, []);

    const openDeleteModal = useCallback((banner: T) => {
        setAction({ type: 'delete', banner });
    }, []);

    return {
        action,
        clearAction,
        openCreateModal,
        openEditModal,
        openViewModal,
        openDeleteModal,
    };
};
